import { render, staticRenderFns } from "./AstralFSNPage.vue?vue&type=template&id=28de14d2&"
import script from "./AstralFSNPage.vue?vue&type=script&lang=js&"
export * from "./AstralFSNPage.vue?vue&type=script&lang=js&"
import style0 from "./AstralFSNPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports